import c from "../../utils/constants";

class SurveyController {
  constructor(SurveyService, FilterService, $scope) {
    "ngInject"
    this.surveyService = SurveyService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.surveyResponseOptions = {
      dataSource: [
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
        { value: 3, text: "NA" },
      ],
      dataTextField: "text",
      dataValueField: "value"
    }

  }

  getGridOptions() {
    debugger;
    return {
      dataSource: this.surveyService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        { field: "responseDate", title: "Date", template: `<span>#= kendo.toString(new Date(responseDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "6rem" },
        { title: "Name", template: `<a class="cell" href="#= '/users/' + jugglerId #">#= fullName #</a>`, filterable: false, sortable: false, width: "10rem" },
        { field: "jugglerType", title: "Type", filterable: false, sortable: true, width: "4rem", template: (dataItem) => `${this._getJugglerType(dataItem.jugglerType)}` },
        { field: "email", title: "Email", filterable: false, sortable: false, width: "8rem" },
        { field: "interestInHomeAgedCareResponse", title: "Response", filterable: false, sortable: true, width: "8rem", template: (dataItem) => `${this._getSurveyResponse(dataItem.interestInHomeAgedCareResponse)}` },
       ],      
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.surveyMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getSurveyResponse(status) {
    switch (status) {
      case c.surveyResponse.YES:
        return "Yes";
      case c.surveyResponse.NO:
        return "No";
      case c.surveyResponse.NA:
        return "NA";
    }
  }

  _getJugglerType(status) {
    switch (status) {
      case c.jugglerType.PARENT:
        return "Family";
      case c.jugglerType.HELPER:
        return "Helper";
    }
  }



}

export default SurveyController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/survey/survey.controller.js
 **/